export default __webpack_public_path__ + "static/media/iconWifi.34584dbb.svg";